export const LOAD_LOCALE = 'LOAD_LOCALE';
export const LOAD_LOCALE_SUCCEEDED = 'LOAD_LOCALE_SUCCEEDED';

export const GET_LOCALES = 'GET_LOCALES';
export const GET_LOCALES_SUCCEEDED = 'GET_LOCALES_SUCCEEDED';

export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_LOCALE_SUCCEEDED = 'CHANGE_LOCALE_SUCCEEDED';